import { Map, List, fromJS } from 'immutable'
import createReucer from '@/models/createReucer'
import {
  GET_ORDER_SUCCESS,
  ORDER_UPDATED,
  ADD_MEMO_SUCCESS,
  TOGGLE_MODAL,
  ADD_ORDER,
  ORDERS_FETCHED,
  TASK_FETCHED
} from './actionTypes'
import Order from './defines/Order'
import { CONVERSATIONS_FETCHED } from '../conversations/actionTypes'

const initializeState = Map({
  entries: Map(),
  list: List(),
  total: 0,
  loading: false
})

export default createReucer({
  [CONVERSATIONS_FETCHED]: (state, { payload }) => {
    const { data, type } = payload;
    const orders = data.map(conv => conv.order)
    return state.withMutations(mutable => {
      orders.forEach(order => {
        if (!mutable.hasIn(['entries', order._id])) {
          mutable.mergeDeepIn(['entries', order._id], new Order(order))
        }
      });
    })
  },
  [TASK_FETCHED]: (state, { payload }) => {
    const { data } = payload;
    const orders = data.map(conv => conv.order)
    return state.withMutations(mutable => {
      orders.forEach(order => {
        if (!mutable.hasIn(['entries', order._id])) {
          mutable.mergeDeepIn(['entries', order._id], new Order(order))
        }
      });
    })
  },

  // DEPRECATED
  [ORDERS_FETCHED]: (state, { payload }) => {
    const { data: orders, total } = payload
    const ids = List(orders.map(item => item._id))

    return state.withMutations(mutable => {
      mutable.set('total', total)
      mutable.set('list', ids)

      orders.forEach(order => {
        if (!mutable.hasIn(['entries', order._id])) {
          mutable.mergeDeepIn(['entries', order._id], new Order(order))
        }
      });
    })
  },

  // 只需更新当前order，并不会增加到列表中
  [GET_ORDER_SUCCESS]: (state, { payload }) =>
    state.setIn(['entries', payload._id], new Order(payload)),

  // 这里应该用merge，没有的亲口下再用new Order
  [ORDER_UPDATED]: (state, { payload }) =>
    state.setIn(['entries', payload._id], new Order(payload)),

  [ADD_MEMO_SUCCESS]: (state, { payload }) => {
    const memos = state.getIn(['entries', payload.id, 'memo'], List()).unshift(Map({
      memo: payload.memo,
      createdAt: new Date()
    }))

    return state.setIn(['entries', payload.id, 'memo'], memos)
  },

  [ADD_ORDER]: (state, { payload }) => state.withMutations(orderState => {
    orderState
      .setIn(['entries', payload._id], new Order(payload))
  }),
}, initializeState)
